angular.module('eCareVault.common.analyticsReport', []);